import { render, staticRenderFns } from "./CompanyVouchersHistory.vue?vue&type=template&id=478ef92e"
import script from "./CompanyVouchersHistory.vue?vue&type=script&lang=js"
export * from "./CompanyVouchersHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports